import { readable } from 'svelte/store';
import { debounce } from '@cdellacqua/debounce';
import { windowShim } from '../ssr-shim.js';
export var Orientation;
(function (Orientation) {
    Orientation[Orientation["Landscape"] = 0] = "Landscape";
    Orientation[Orientation["Portrait"] = 1] = "Portrait";
})(Orientation || (Orientation = {}));
let orientationMediaQuery;
function getOrientationMediaQuery() {
    if (!orientationMediaQuery) {
        orientationMediaQuery = windowShim.matchMedia('(orientation: portrait)');
    }
    return orientationMediaQuery;
}
function getOrientation() {
    return getOrientationMediaQuery().matches ? Orientation.Portrait : Orientation.Landscape;
}
function makeOrientationStore(debounced) {
    let previousValue;
    return readable(undefined, (set) => {
        const update = () => {
            const currentValue = getOrientation();
            if (currentValue !== previousValue) {
                previousValue = currentValue;
                set(currentValue);
            }
        };
        update();
        const changeHandler = debounced ? debounce(update) : update;
        getOrientationMediaQuery().addEventListener('change', changeHandler);
        return () => {
            getOrientationMediaQuery().removeEventListener('change', changeHandler);
        };
    });
}
/**
 * A readable store that indicates whether the viewport is in landscape or portrait mode (debounced).
 */
export const orientation = makeOrientationStore(true);
/**
 * A readable store that indicates whether the viewport is in landscape or portrait mode (undebounced).
 */
export const orientationUndebounced = makeOrientationStore(false);
